import { INT_ADJUSTMENTS } from "../constants/abilityAdjustments";

export function calculateIntBonus(character) {

  let intLookupKey = character.stats['myInt'].toString().replace(/[^0-9]/g, ''); // strip out non-numerical

  const charClass = character.chars.myClass

  let INT_bonus_string ="";
  try {
    const INT_adj = INT_ADJUSTMENTS[parseInt(intLookupKey)]
      console.log('INT adj: ',INT_adj)

      let adjuster = INT_adj['spellchance'];
      const bonus = adjuster === 0 ? "" :
        `${adjuster}%`;
      console.log('Spell chance: ', bonus);

      INT_bonus_string = bonus

      // bonus string is only for magic-users and illusionists
      if ( ! ["Magic-User","MU", "Mu", "mu", "mage", "Ma", "ma", "Mage", "Illusionist", "Ill", "ill", "Ranger", "Rgr", "Ran", "rgr", "ran"].some(str => charClass.includes(str)) ) {
        INT_bonus_string = ""
      }   
      
      return { str: INT_bonus_string, dict: INT_adj }
    
  } catch(error) {
    console.log('fail gracefully')
    console.log(error)
  }

}